import { combineReducers } from "redux";
import wordReducer from './wordReducer';
import jokeReducer from './jokeReducer';
import authReducer from './authReducer';

export default combineReducers({ wordReducer, jokeReducer, authReducer });
